const g = (o, i) => ({ isIconLeftAndRight: o && i, isIconLeftOnly: o && !i, isIconRightOnly: !o && i }), d = (o, i) => {
  const { isIconLeftAndRight: r, isIconLeftOnly: $, isIconRightOnly: e } = g(o, i), n = "10px", c = "24px", s = "21px";
  return $ ? `${n} ${c} ${n} ${s}` : e ? `${n} ${s} ${n} ${c}` : r ? `${n} ${s}` : `${n} ${c}`;
}, p = (o, i) => {
  const { isIconLeftAndRight: r, isIconLeftOnly: $, isIconRightOnly: e } = g(o, i), n = "12px", c = "32px", s = "0px", I = "0px", t = "0px";
  return $ ? `${t} ${I} ${t} ${n}` : e ? `${t} ${c} ${t} ${s}` : r ? `${t} ${c} ${t} ${n}` : `${t} ${s} ${t} ${I}`;
};
export {
  p as getInputMarginForIcons,
  d as getInputPaddingForIcons
};
